module.exports = __webpack_public_path__ + "static/media/wallet-oldie.13bd98de.svg";